import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c3f9445a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-container" }
const _hoisted_2 = {
  key: 0,
  class: "footer xag-page__footer nongfu-button-wrap"
}

import { Button } from 'vant'
import { useRouter, useRoute } from 'vue-router'
import { Ref, ref } from 'vue'
import { WuyouRenderListItemType, DevicePayInfoType } from '@/types/insurance'
import { getThousandMoney } from '@/utils/index'
import { confirmWuyouOrderApplyInvoice } from '@/apis/insurance'
import { ConfirmUseStorageData } from '@/types/invoice'
import { showToastLoading, clearToast, showConfirmModal, showToastFail } from '@/utils/tools'
import AppHeader from '@/components/Header.vue'
import OrderApply from '@/components/invoice/order-apply.vue'
import DevicePayInfo from '../components/device-pay-info.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'apply-invoice',
  setup(__props) {

const detail: Ref<DevicePayInfoType | null> = ref(null)
const $router = useRouter()
const $route = useRoute()
const routeQuery = $route.query
const hasInvoiceInfo = ref(false)
const cacheKey = routeQuery.cacheKey as string
let invoiceInfo: ConfirmUseStorageData | null = null

const cacheDetailStoarageData: WuyouRenderListItemType | null = JSON.parse(
  sessionStorage.getItem(cacheKey)
)

async function submitInvoiceApply() {
  try {
    await showConfirmModal({
      message: '是否确认提交发票申请?',
      className: 'repair-dialog',
    })
    showToastLoading()
    const params = {
      invoice_guid: invoiceInfo.invoice.guid,
      invoice_type: '1',
    }
    await confirmWuyouOrderApplyInvoice(cacheDetailStoarageData.guid, params)
    clearToast()
    $router.go(-1)
  } catch (error) {
    console.log('error', error)
    if (error) {
      const message = error?.message || '申请失败'
      showToastFail(message)
    }
  }
}
async function initPageDetail() {
  if (!cacheDetailStoarageData) {
    return
  }
  detail.value = {
    deviceCommonInfo: {
      img: cacheDetailStoarageData.logo_url,
      name: cacheDetailStoarageData.model_name,
      sequence: cacheDetailStoarageData.serial_number,
    },
    serviceInfoList: [
      {
        label: '设备型号',
        value: cacheDetailStoarageData.model_name,
      },
      {
        label: '无忧计划',
        value: `${cacheDetailStoarageData.safeguard_start_at} 至 ${cacheDetailStoarageData.safeguard_end_at}`,
      },
      {
        label: '服务说明',
        value: cacheDetailStoarageData.definition_description,
      },
    ],
    buyInfo: {
      title: cacheDetailStoarageData.definition + '服务费',
      price: getThousandMoney(Number(cacheDetailStoarageData.price)),
    },
  }
}
function invoiceInit(data: ConfirmUseStorageData) {
  invoiceInfo = data
  hasInvoiceInfo.value = !!invoiceInfo?.needInvoice
}
initPageDetail()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(AppHeader, { title: "发票申请" }),
    _createElementVNode("section", _hoisted_1, [
      _createVNode(DevicePayInfo, { detail: detail.value }, null, 8, ["detail"]),
      _createVNode(OrderApply, { onInvoiceInit: invoiceInit })
    ]),
    (detail.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_unref(Button), {
            class: "xa-vant-button",
            onClick: submitInvoiceApply,
            block: "",
            round: "",
            type: "success",
            disabled: !hasInvoiceInfo.value
          }, {
            default: _withCtx(() => [
              _createTextVNode("提交发票申请")
            ]),
            _: 1
          }, 8, ["disabled"])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})